import React from 'react'
import { Link } from 'react-router-dom'
import ReactStars from 'react-rating-stars-component'

const SpecialProduct = () => {
  return (
    <div className="col-4">
        <div className="special-product-card">
            <div className="d-flex justify-content-bewteen">
                <div>
                    <img src="images/watch.jpg" className="img-fluid" alt="watch" />
                </div>
                <div className="spectial-product-content">
                    <h5 className="brand">Adidis</h5>
                    <h6 className="title">
                        Lorem ipsum dolor sit amet.
                    </h6>
                    <ReactStars count={5} size={24} activeColor="#ffd700" edit={true} value={3} />      
                    <p className="price">
                        <span className="text-danger">$100</span>&nbsp;
                        <strike>$200</strike>
                    </p>
                    <div className="discount-till d-flex align-items-center gap-10">
                        <p className='mb-0'>
                            <b>5</b> days
                        </p>
                        <div className="d-flex gap-10 align-items-center">
                            <span className="badge p-2 bg-danger rounded-circle">1</span>:
                            <span className="badge p-2 bg-danger rounded-circle">1</span>:
                            <span className="badge p-2 bg-danger rounded-circle">1</span>
                        </div>
                    </div>
                    <div className="prod-count my-3">
                            <p>Products: 5</p>
                            <div className="progress">
                                <div 
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width:'25%' }}
                                >
                             </div>    
                        </div>
                    </div>
                    <Link className="button" to="#">Add To Cart</Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SpecialProduct